import React from 'react'
import NotFound404 from '../components/404'
import ComparisonPage from '../components/comparison'
import DeviceSelector from '../components/DeviceSelector'
function ComparePage  ()  {
  return (
    <div>
 
<ComparisonPage />

      {/* <NotFound404 /> */}
    </div>
  )
}

export default ComparePage
